var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBomb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16mm",
    height: "16.009mm",
    viewBox: "0 0 16 16.009",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25.449 -39.33)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26.234,
    y: 46.81,
    width: 14.429,
    height: 1.05,
    style: {
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-90)",
    x: -54.549,
    y: 32.924,
    width: 14.429,
    height: 1.05,
    style: {
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.3403 .06246 -.06246 .3403 64.505 64.974)",
    d: "m-88.654-20.771-11.901 2.3926-10.107-6.7237-2.3926-11.901 6.7237-10.107 11.901-2.3926 10.107 6.7237 2.3926 11.901z",
    style: {
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.697 42.002a0.58465 0.60804 0 0 0-0.58446 0.60823 0.58465 0.60804 0 0 0 0.58446 0.60823 0.58465 0.60804 0 0 0 0.22479-0.04754l1.4258 1.6304 0.30127-0.26303-1.4361-1.6423a0.58465 0.60804 0 0 0 0.06925-0.28577 0.58465 0.60804 0 0 0-0.58498-0.60823z",
    style: {
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.285 52.685a0.58465 0.60804 0 0 0 0.58446-0.60823 0.58465 0.60804 0 0 0-0.58446-0.60823 0.58465 0.60804 0 0 0-0.22479 0.04754l-1.4258-1.6304-0.30127 0.26303 1.4361 1.6423a0.58465 0.60804 0 0 0-0.06925 0.28577 0.58465 0.60804 0 0 0 0.58498 0.60823z",
    style: {
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.344 42.23c2.261 2.2156 2.2668 2.2214 2.2668 2.2214",
    style: {
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.946 42.604a0.58465 0.60804 82.663 0 0-0.67789-0.502 0.58465 0.60804 82.663 0 0-0.52861 0.65735 0.58465 0.60804 82.663 0 0 0.07586 0.21688l-1.435 1.6223 0.29936 0.26521 1.4454-1.6341a0.58465 0.60804 82.663 0 0 0.29228 0.03214 0.58465 0.60804 82.663 0 0 0.52854-0.65786z",
    style: {
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.127 52.162a0.58465 0.60804 86.164 0 0 0.64597 0.54246 0.58465 0.60804 86.164 0 0 0.56777-0.62384 0.58465 0.60804 86.164 0 0-0.06247-0.22111l1.5314-1.5316-0.2826-0.283-1.5425 1.5427a0.58465 0.60804 86.164 0 0-0.28976-0.04997 0.58465 0.60804 86.164 0 0-0.56773 0.62436z",
    style: {
      paintOrder: "fill markers stroke"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 30.218,
    y: 44.066,
    width: 1.9678,
    height: 2.0671,
    fill: "#fff",
    style: {
      paintOrder: "fill markers stroke"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBomb);
export default __webpack_public_path__ + "static/media/Bomb.e7c079de63a239f8ce1e4ddc4f533bc6.svg";
export { ForwardRef as ReactComponent };